import {
	Component,
	Input,
	AfterContentInit,
	ContentChildren,
	QueryList,
	ChangeDetectorRef,
	OnDestroy,
	ChangeDetectionStrategy,
	EventEmitter
} from '@angular/core';
import { GridApi, GridOptions, SORT_ORDER } from './grid-api.service';
import { Subscription } from 'rxjs';
import { GridColumn } from './grid-column.directive';
import * as Immutable from 'immutable';

@Component({
	selector: 'vcm-grid',
	template: require('./grid.component.html'),
	// changeDetection: ChangeDetectionStrategy.OnPush, //@TODO Uncomment when https://github.com/angular/angular/issues/12378 will be closed.
	providers: [GridApi]
})
export class GridComponent implements AfterContentInit, OnDestroy {
	@Input() gridOptions: GridOptions;
	@Input() rows: any[] = [];
	@Input() trackByKey: string;
	@Input() dataChanged: EventEmitter<void>;
	@Input() sortByDefaultColumn: string;

	@Input() set search(search: string) {
		this.gridApi.search = search;
	}

	@Input() set filter(filter: Immutable.Map<string, string>) {
		filter = filter || Immutable.Map<string, string>();
		this.gridApi.filter = filter;
	}

	@ContentChildren(GridColumn) columns: QueryList<GridColumn>;

	private _columnsSubscription: Subscription;
	private _gridSubscription: Subscription;

	constructor(private detector: ChangeDetectorRef,
	            public gridApi: GridApi) {
	}

	ngAfterContentInit() {
		this.gridOptions || (this.gridOptions = {});
		this.gridOptions.api = this.gridApi;
		this._columnsSubscription = this.columns.changes.subscribe(() => this.detector.markForCheck());
		if (this.dataChanged) {
			this._gridSubscription = this.dataChanged.subscribe(() => this.detector.markForCheck());
		}
	}

	getOrder(column: GridColumn): SORT_ORDER {
		if(this.sortByDefaultColumn){
			return column.key === this.sortByDefaultColumn ? column.sortOrder : null
		}

		return this.gridApi.sort.key === column.key ? this.gridApi.sort.order : null;
	}

	changeSorting(column: GridColumn, order: SORT_ORDER): void {
		this.sortByDefaultColumn = null;
		this.gridApi.sort = {key: column.key, order: order, type: column.type};
	}

	changeFilter(column: GridColumn, filterValue: string): void {
		this.gridApi.filter = this.gridApi.filter.set(column.key, filterValue);
	}

	columnTrackBy(index: number, column: GridColumn) {
		return column.key || index;
	}

	rowsTrackBy(index: number, data: any) {
		return this.trackByKey ? data[this.trackByKey] : index;
	}

	ngOnDestroy() {
		this._columnsSubscription.unsubscribe();
		if (this._gridSubscription) {
			this._gridSubscription.unsubscribe();
		}
	}
}